import $ from 'jquery';
import { defaultOptions } from '../../tippy-util.js';

/**
 * @param {JQuery} $trigger
 * @param {JQuery} $container
 * @param {JQuery} $content
 * @param {Partial<import('tippy.js').Props>} options
 */
export default async ($trigger, $container, $content, options = {}) => {

	// Import the tippy lib lazily
	const { 'default': tippy } = await import('tippy.js');

	// @ts-ignore
	const instance = tippy($trigger[0], {

		// Merge with default config
		...defaultOptions,

		appendTo: $container[0],
		content: _ => $content[0],
		placement: 'bottom-start',
		popperOptions: {
			modifiers: [
				...defaultOptions.popperOptions.modifiers,
				{ name: 'flip', enabled: true },
				{
					name: 'preventOverflow',
					enabled: true,
					options: {
						rootBoundary: document.body,
					},
				},
			],
		},
		trigger: 'click',
		// Merge with provided options
		...options,
	});

	return instance;
};
